export default __webpack_public_path__ + "static/media/T43.a4108a86.JPG";